import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Check, ChevronDown, ChevronRight, Copy } from "react-feather";

interface JsonBlockProps {
  value: unknown;
  title?: string;
  /** Collapsed by default so the raw payload never buries the summary. */
  defaultOpen?: boolean;
  maxHeight?: number;
}

export const JsonBlock: React.FC<JsonBlockProps> = ({
  value,
  title = "Raw JSON",
  defaultOpen = false,
  maxHeight = 420,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const [copied, setCopied] = useState(false);
  const text = JSON.stringify(value, null, 2);

  const copy = async () => {
    await navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="border rounded mt-3">
      <div className="d-flex justify-content-between align-items-center px-3 py-2 bg-light border-bottom">
        <button
          type="button"
          className="btn btn-link btn-sm p-0 text-decoration-none fw-bold"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? (
            <ChevronDown size={14} className="me-1" />
          ) : (
            <ChevronRight size={14} className="me-1" />
          )}
          {title}
        </button>
        <Button size="sm" variant="outline-secondary" onClick={copy}>
          {copied ? <Check size={14} /> : <Copy size={14} />}
          <span className="ms-1">{copied ? "Copied" : "Copy"}</span>
        </Button>
      </div>
      {open && (
        <pre
          className="mb-0 p-3 small"
          style={{ maxHeight, overflow: "auto", whiteSpace: "pre-wrap" }}
        >
          {text}
        </pre>
      )}
    </div>
  );
};
